module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_okunai_tvb-9201c84b5ae7b1188bcca9c95cf13138.jpg";